/* Dansk katalog for locale-no.js (del 10 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'ha.dragWidth': 'Træk for at ændre bredde',
  'ha.changeWidth': 'Skift bredde',
  'err.auth.required': 'Du skal logge ind først.',
  'err.auth.emailNotVerified': 'Bekræft din e-mailadresse først. Vi har sendt dig et link — åbn det, og prøv igen.',
  'err.auth.sessionRevoked': 'Sessionen er afsluttet. Log ind igen.',
  'err.invoice.publicLinkExpired': 'Dette link er udløbet. Bed afsenderen sende dokumentet igen.',
  'err.business.alreadyVerified': 'Denne virksomhed er allerede registreret i Plumme. Bed ejeren invitere dig.',
  'err.business.idPortenRequired': 'Log ind med ID-porten for at verificere virksomheden.',
  'err.business.notAnAltinnActor': 'Du står ikke som aktør for denne virksomhed i Altinn.',
  'err.business.altinnUnavailable': 'Kunne ikke slå dine roller op i Altinn lige nu. Prøv igen senere.',
  'err.email.invalid': 'Indtast en gyldig e-mailadresse.',
  'err.pf.notCreated': 'Opret Privatøkonomi, før du tilknytter en husstand.',
  'err.pf.noAccess': 'Du har ikke adgang til denne Privatøkonomi-klient.',
  'err.household.alreadyLinked': 'Du er allerede tilknyttet en husstand.',
  'err.household.notLinked': 'Du er ikke tilknyttet en husstand.',
  'err.household.selfInvite': 'Du kan ikke invitere dig selv.',
  'err.household.selfLink': 'Du kan ikke tilknytte dig selv.',
  'err.household.invitePending': 'Der findes allerede en ventende invitation til denne e-mailadresse.',
  'err.household.invalidResponse': 'Ugyldigt svar på invitationen.',
  'err.household.inviteNotFound': 'Invitationen findes ikke.',
  'err.household.inviteOtherEmail': 'Invitationen tilhører en anden e-mailadresse.',
  'err.household.inviteInactive': 'Invitationen er ikke længere aktiv.',
  'err.household.someoneLinked': 'En af brugerne er allerede tilknyttet en husstand.',
  'err.household.cannotWithdraw': 'Du kan ikke trække denne invitation tilbage.',
  'err.business.missing': 'Mangler aktiv virksomhed.',
  'err.business.notFound': 'Virksomheden findes ikke.',
  'err.business.dataNotFound': 'Virksomhedsdata findes ikke.',
  'err.import.noAccess': 'Du har ikke adgang til at importere regnskab for denne virksomhed.',
  'err.import.jobMissing': 'Mangler importjob.',
  'err.import.jobNotFound': 'Importjobbet findes ikke.',
  'err.import.packageMissingFile': 'Den gemte import mangler filreference. Upload filerne igen.',
  'err.import.packageAlreadyCommitted': 'Det samme sæt importfiler er allerede importeret. Slet dubletten på listen over gemte importpakker.',
  'err.import.packageActive': 'Dette er den aktive importpakke, og den kan ikke slettes. Slet en ældre pakke i stedet.',
  'err.advisor.insightIncomplete': 'AI-rådet blev afbrudt, før det var færdigt. Prøv igen om lidt.',
  'err.advisor.insightUnavailable': 'SuperPlumma kunne ikke lave et sikkert råd ud fra dette grundlag lige nu.',
  'err.advisor.insightEmpty': 'SuperPlumma fik ikke lavet et færdigt råd. Prøv igen om lidt.',
  'err.import.notAnalyzed': 'Importjobbet skal være analyseret, før det kan godkendes.',
  'err.import.noProposal': 'Importjobbet mangler grundlagsforslag.',
  'err.pf.clientMissing': 'Mangler privatøkonomi-klient.',
  'err.pf.clientNotFound': 'Privatøkonomi-klienten findes ikke.',
  'err.pf.notPersonalClient': 'Denne klient er ikke en privatøkonomi-klient.',
  'err.pf.noValidFields': 'Ingen gyldige privatøkonomifelter at gemme.',
  'err.tx.pickAtLeastOne': 'Vælg mindst én transaktion.',
  'err.tx.maxBatch': 'Du kan flytte højst 200 transaktioner ad gangen.',
  'err.tx.pickCategory': 'Vælg kategori.',
  'err.tx.notFound': 'En eller flere transaktioner findes ikke.',
  'err.tx.otherClient': 'Transaktionen tilhører ikke denne klient.',
  'err.statement.missing': 'Mangler kontoudskrift.',
  'err.statement.notFound': 'Kontoudskriften findes ikke.',
  'err.account.pickOrCreate': 'Vælg eller opret konto.',
  'err.account.missing': 'Mangler konto.',
  'err.account.notFound': 'Kontoen findes ikke.',
  'err.account.hasTransactions': 'Kontoen har importerede transaktioner. Slet kontoudskriften først.',
  'err.asset.missing': 'Mangler aktiv.',
  'err.asset.notFound': 'Aktivet findes ikke.',
  'err.loan.missing': 'Mangler lån.',
  'err.loan.notFound': 'Lånet findes ikke.',
  'err.assistant.emptyQuestion': 'Skriv et spørgsmål først.',
  'err.assistant.tooLong': 'Beskeden er for lang.',
  'err.assistant.conversationLimit': 'Samtalen har nået grænsen. Start en ny samtale for at fortsætte.',
  'err.idporten.expired': 'ID-porten-token mangler eller er udløbet. Log ind med ID-porten igen.',
  'pref.title': 'Præferencer',
  'pref.sub': 'Justér notifikationer, sprog, tema og standardarbejdsgang.',
  'pref.deadlineMail': 'E-mailpåmindelser om frister',
  'pref.deadlineMailSub': 'Få en e-mail 7 dage før momsfrister og 30 dage før skattemelding, årsregnskab og aksjonærregisteroppgave. Gælder norske virksomheder, hvor du er ejer eller administrator.',
  'pref.deadlineMailNotManager': 'Du er ikke ejer eller administrator i denne virksomhed, så du får ingen påmindelser om frister for den.',
  'pref.language': 'Sprog',
  'pref.languageSub': 'Dit sprog på tværs af virksomheder. Andre brugere beholder deres sprog. Regnskabsregler og valuta følger virksomhedens land.',
  'pref.mascots': 'Maskotbilleder',
  'pref.mascotsSub': 'Vis SuperPlumma og de andre maskotter i appen.',
  'pref.theme': 'Tema',
  'pref.theme.light': 'Lyst',
  'pref.theme.dark': 'Mørkt',
  'pref.saved': 'Præferencer gemt',
  'set.transitionImport.title': 'Importér overgangsfil',
  'set.transitionImport.help': 'Brug SAF-T XML, Excel eller CSV med konto og enten debet/kredit eller saldo med fortegn. Filen behandles som starttal eller åbningsbalance, ikke som komplet historik.',
  'set.transitionImport.choose': 'Vælg fil',
  'set.transitionImport.readError': 'Kunne ikke læse overgangsfilen.',
  'set.transitionImport.summaryBalance': 'Læste {accounts} konti og {balanceLines} balancelinjer. Kontrollér tallene, før du gemmer.',
  'set.transitionImport.summaryStartup': 'Læste {accounts} konti: {salesLines} indtægtslinjer, {costLines} omkostningslinjer, udgående moms {outgoingVat} og indgående moms {incomingVat}. Kontrollér tallene, før du gemmer.',
  'set.transitionImport.includeVat': 'Medtag momsbeløbene i en MVA-melding i Plumme',
  'set.transitionImport.includeVatHelp': 'Slå kun dette til, hvis beløbene ikke allerede er indberettet fra det tidligere system. Ellers bliver momsen talt med to gange.',
  'set.transitionImport.vatPeriod': 'Momsperiode, der skal modtage starttallene',
  'set.transitionImport.chooseVatPeriod': 'Vælg periode',
  'set.transitionImport.chooseVatPeriodError': 'Vælg, hvilken momsperiode starttallene skal medtages i.',
  'set.transitionImport.vatFootnote': 'Startmoms gemmes som overgangsgrundlag. Den tilføjes kun til en MVA-melding, når du aktivt vælger perioden ovenfor.',
  'set.transitionImport.useSimple': 'Brug simpel overgang',
  'set.transitionImport.simpleTitle': 'De fleste bør bruge en simpel overgang',
  'set.transitionImport.simpleHelp': 'Ved et nyt regnskabsår er en åbningsbalance som regel nok. Ved skift midt i året kan du bruge starttal. Begge kan udfyldes manuelt eller importeres fra SAF-T eller saldobalance under Regnskab.',
  'set.transitionImport.completeTitle': 'Komplet historikimport er avanceret',
  'set.transitionImport.completeRisk': 'Eksporter fra andre regnskabssystemer kan indeholde forskelle, mangler eller korrektioner, som ikke kan tolkes sikkert.',
  'set.transitionImport.completeCheck': 'Kontrollér åbningsbalance, momsbeløb og indsendelsesstatus mod det tidligere system og myndighedernes arkiver.',
  'set.transitionImport.completeKeep': 'Behold den oprindelige eksport og regnskabsdokumentationen i hele opbevaringsperioden.',
  'set.transitionImport.completeAccept': 'Jeg forstår, at importerede oplysninger skal kontrolleres, før jeg indberetter eller korrigerer noget.',
  'set.transitionImport.error.noRows': 'Filen indeholder ingen saldolinjer.',
  'set.transitionImport.error.noAccount': 'Filen skal have en kolonne for konto eller kontonummer.',
  'set.transitionImport.error.ambiguousAmount': 'Filen skal have separate debet- og kreditkolonner eller beløb sammen med en sidekolonne.',
  'set.transitionImport.error.notBalanced': 'Indgående balance balancerer ikke. Debet {debit} og kredit {credit} skal være ens.',
  'set.transitionImport.error.fileType': 'Vælg SAF-T XML eller en CSV- eller tekstfil med saldobalance.',
  'set.transitionImport.warning.noSaftBalances': 'Fandt ingen kontosaldi i SAF-T-filen.',
  'set.transitionImport.warning.noBalances': 'Fandt ingen saldi med beløb i filen.',
  'set.transitionImport.lineNote': 'Importeret fra {source}',
  'set.transitionImport.note': 'Importeret fra {source}. Kontrollér saldiene mod det tidligere regnskabssystem.',
  'set.transitionImport.accountName': 'Konto {account}',
  'set.transitionImport.sourceTrialBalance': 'saldobalance',
  'set.transitionImport.yearMismatch': 'Filen gælder overgang til {detectedYear}, men startår er sat til {selectedYear}. Ændr startår, eller vælg den rigtige fil.',
  'importCompliance.warningTitle': 'Kontrollér importerede oplysninger',
  'importCompliance.warningBody': 'Oplysningerne er hentet fra et andet regnskabssystem. Plumme kontrollerer, at dataene kan læses og behandles, men kan ikke bekræfte, at eksporten er fuldstændig, at tallene er korrekte, eller at indberetningerne er modtaget af myndighederne. Kontrollér mod det tidligere regnskabssystem og myndighedernes arkiver, hvis du er i tvivl.',
  'importCompliance.historicalTitle': 'Historiske år markeres som færdige',
  'importCompliance.historicalBody': 'For komplette år ældre end sidste år ({years}) markeres årsafslutning og relevante indberetninger som indsendt. Importerede momsperioder markeres som indsendt, men ikke som betalt.',
  'importCompliance.previousTitle': 'Bekræft status for {year}',
  'importCompliance.previousHelp': 'Vi antager ikke, at sidste år er færdigt. Vælg »Usikker«, hvis det skal kontrolleres; så forbliver opgaven åben.',
  'importCompliance.question.yearClosing': 'Er årsafslutningen færdig?',
  'importCompliance.question.taxReturn': 'Er skattemeldingen indsendt?',
  'importCompliance.question.annualAccounts': 'Er årsregnskabet indsendt?',
  'importCompliance.question.vatReturns': 'Er MVA-meldingerne for de importerede perioder indsendt?',
  'importCompliance.selectStatus': 'Vælg status',
  'importCompliance.yes': 'Ja',
  'importCompliance.no': 'Nej',
  'importCompliance.unknown': 'Usikker – hold åben',
  'importCompliance.accept': 'Jeg forstår, at importerede tal og historiske indsendelsesstatusser skal kontrolleres mod det tidligere regnskabssystem og myndighedernes arkiver.',
  'importCompliance.noPaymentAssumption': 'Betalingsstatus for moms antages ikke, blot fordi en periode er gammel.',
  'importCompliance.noticeTitle': 'Importerede oplysninger for {year}',
  'importCompliance.area.vat': 'MVA-meldingerne',
  'importCompliance.area.tax': 'skattemeldingen',
  'importCompliance.area.annualAccounts': 'årsregnskabet',
  'importCompliance.area.yearClosing': 'årsafslutningen',
  'importCompliance.statusDelivered': '{area} står som {status} på baggrund af importvalget.',
  'importCompliance.statusOpen': '{area} er holdt åben.',
  'importCompliance.statusNotApplicable': '{area} er ikke markeret som indsendelsespligtig for denne virksomhedsform.',
  'importCompliance.statusFiled': 'indsendt',
  'importCompliance.statusClosed': 'færdig',
  'importCompliance.noticeBody': 'Tal og historiske statusser er hentet fra et andet regnskabssystem. Plumme kan ikke bekræfte, at eksporten er fuldstændig, at tallene er korrekte, eller at indberetningen er modtaget af myndighederne. Kontrollér mod det tidligere regnskabssystem og myndighedernes arkiver, før du foretager ændringer eller indsender.',
  'importCompliance.understood': 'Jeg forstår',
  'importOpen.title': 'Importeret reskontro',
  'importOpen.items': 'poster',
  'importOpen.customerInvoice': 'Faktura',
  'importOpen.supplierInvoice': 'Leverandørfaktura',
  'importOpen.noDate': 'uden dato',
  'importOpen.due': 'Forfald {date}',
  'importOpen.controlBasis': 'importeret kontrolgrundlag',
  'importOpen.open': 'Importeret åben post',
  'importOpen.partial': 'Delvist udlignet',
  'importOpen.settled': 'Udlignet',
  'importOpen.credit': 'Kredit / overbetaling',
  'importOpen.registerSettlement': 'Registrér udligning',
  'importOpen.dialogTitle': 'Registrér udligning af importeret post',
  'importOpen.amount': 'Udlignet beløb',
  'importOpen.date': 'Udligningsdato',
  'importOpen.note': 'Bemærkning (valgfrit)',
  'importOpen.noPostingNotice': 'Udligningen bogføres mod den valgte bankkonto og den importerede debitor- eller kreditorreskontro. Der oprettes ingen ny indtægt, omkostning eller moms.',
  'importOpen.settledToast': 'Udligningen er registreret',
  'importOpen.reopenedToast': 'Den importerede post er genåbnet',
  'importOpen.error': 'Kunne ikke opdatere den importerede post',
  'importOpen.reopen': 'Genåbn',
  'importOpen.reopenTitle': 'Genåbn importeret post',
  'importOpen.reopenWarning': 'Posten bliver igen udestående, og den bogførte udligning tilbageføres på den valgte dato.',
  'inv.detail.overpaid': 'Overbetalt',
  'inv.detail.customerOverpayment': 'Uafklaret tilgodehavende hos kunden',
  'inv.detail.registerExtraPayment': 'Registrér ekstra indbetaling',
  'inv.pay.overpaymentNote': 'Indbetalingen er {amount} højere end fakturaens restbeløb. Hele beløbet registreres, og det overskydende bliver stående som uafklaret tilgodehavende på kunden.',
  'inv.overpayment.refund': 'Tilbagebetal overbetaling',
  'inv.overpayment.allocate': 'Fordel overbetaling',
  'inv.overpayment.available': 'Tilgængelig ufordelt overbetaling: {amount}.',
  'inv.overpayment.source': 'Overbetaling fra faktura',
  'inv.overpayment.allocations': 'Fordelinger af overbetaling',
  'inv.overpayment.receivedFrom': 'Modtaget fra {document}',
  'inv.overpayment.allocatedTo': 'Fordelt til {document}',
  'inv.overpayment.refundNote': 'Tilbagebetaling af kundeoverbetaling',
  'inv.overpayment.allocationNote': 'Fordelt kundeoverbetaling fra {source}',
  'inv.overpayment.refunded': 'Overbetalingen er tilbagebetalt',
  'inv.overpayment.allocated': 'Overbetalingen er fordelt',
  'inv.overpayment.reverseRefund': 'Tilbagefør tilbagebetaling',
  'inv.overpayment.reverseAllocation': 'Tilbagefør fordeling',
  'inv.overpayment.notConnected': 'Tilbagebetaling af overbetaling er ikke tilsluttet backend.',
  'inv.overpayment.noSource': 'Vælg en faktura med tilgængelig overbetaling.',
  'inv.overpayment.refundFailed': 'Kunne ikke tilbagebetale overbetalingen.',
  'inv.overpayment.allocationFailed': 'Kunne ikke fordele overbetalingen.',
  'inv.overpayment.reverseRefundFailed': 'Kunne ikke tilbageføre tilbagebetalingen.',
  'inv.overpayment.reverseAllocationFailed': 'Kunne ikke tilbageføre fordelingen.',
  'sup.overpayment.invalidAmount': 'Indtast et gyldigt beløb.',
  'sup.overpayment.refunded': 'Tilbagebetalingen er registreret.',
  'sup.overpayment.allocated': 'Overbetalingen er fordelt.',
  'sup.overpayment.failed': 'Kunne ikke behandle overbetalingen.',
  'sup.overpayment.refundTitle': 'Tilbagebetal leverandøroverbetaling',
  'sup.overpayment.allocateTitle': 'Fordel leverandøroverbetaling',
  'sup.overpayment.refundAction': 'Registrér tilbagebetaling',
  'sup.overpayment.allocateAction': 'Fordel overbetaling',
  'sup.overpayment.source': 'Overbetaling fra faktura',
  'sup.overpayment.amount': 'Beløb',
  'sup.overpayment.date': 'Dato',
  'sup.overpayment.bankAccount': 'Bankkonto',
  'sup.overpayment.reverseRefund': 'Tilbagefør tilbagebetaling',
  'sup.overpayment.refundReversed': 'Tilbagebetalingen er tilbageført.',
  'sup.overpayment.reverseRefundFailed': 'Kunne ikke tilbageføre tilbagebetalingen.',
  'sup.overpayment.reverseAllocation': 'Tilbagefør fordeling',
  'sup.overpayment.allocationReversed': 'Fordelingen er tilbageført.',
  'sup.overpayment.reverseAllocationFailed': 'Kunne ikke tilbageføre fordelingen.',
  'settlement.linkExisting': 'Tilknyt eksisterende postering',
  'settlement.title': 'Tilknyt eksisterende postering',
  'settlement.noNewPosting': 'Tilknytningen opdaterer reskontroen. Den opretter ingen ny postering i hovedbogen.',
  'settlement.noMatchesTitle': 'Ingen mulige match',
  'settlement.noMatchesText': 'Kontrollér, at den frie postering bruger kredit 1500 for den valgte kunde eller debet 2400 for den valgte leverandør, og at beløbet ikke allerede er tilknyttet.',
  'settlement.exactMatch': 'Nøjagtigt beløbsmatch',
  'settlement.manualPosting': 'Fri postering',
  'settlement.customerInvoice': 'Kundefaktura',
  'settlement.supplierInvoice': 'Leverandørfaktura',
  'settlement.noDate': 'Uden dato',
  'settlement.canLink': 'Kan tilknyttes: {amount} · Ledigt i posteringen: {available}',
  'settlement.amount': 'Beløb, der skal tilknyttes',
  'settlement.amountTooHigh': 'Beløbet er højere end det disponible beløb.',
  'settlement.linkSelected': 'Tilknyt valgte',
  'settlement.linking': 'Tilknytter…',
  'settlement.linkedOne': 'Posteringen er tilknyttet den åbne post.',
  'settlement.linkedMany': '{count} åbne poster er tilknyttet.',
  'settlement.cardTitle': 'Åbne poster kan tilknyttes',
  'settlement.cardText': 'Vælg selv faktura og beløb. Intet udlignes automatisk.',
  'settlement.linkPosting': 'Tilknyt {voucher}',
  'settlement.linkFailed': 'Posteringen kunne ikke tilknyttes.',
  'settlement.voucherNotFound': 'Bilaget, der skal tilknyttes, blev ikke fundet.',
  'settlement.actionHelp': 'Tilknytter et ubrugt beløb på en fri postering til en åben kunde- eller leverandørpost uden at oprette en ny postering i hovedbogen.',
  'accounting.importedStatisticsTitle': 'Importeret regnskabsstatistik',
  'accounting.importedStatisticsReconciliation': 'Saldiene kommer fra kontrolleret importeret kontostatistik, ikke fra journalhændelser i Plumme. Afstemningen kan gennemgås, men certificering og afslutning er stadig spærret.',
});
